import {fromJS} from 'immutable';

import {
  ADD_FLAG,
  STORE_FLAGS,
  REMOVE_FLAG,
  UPDATE_FLAG_STATUS
} from './actions';


export const initialState = fromJS({
  flags: {},
  error: null,
  status: {
    hasFetched: false,
    isFetching: false
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_FLAG: {
      const {flag, error} = action.payload;

      if (error) {
        return state.setIn(['flags', flag.activityUrl], {error});
      }

      return state.setIn(['flags', flag.activityUrl], fromJS(flag));
    }

    case STORE_FLAGS: {
      const {flags, error} = action.payload;

      if (error) {
        return state.setIn(['status', 'hasFetched'], true)
          .setIn(['status', 'isFetching'], false)
          .set('error', error);
      }

      return state.setIn(['status', 'hasFetched'], true)
        .setIn(['status', 'isFetching'], false)
        .mergeDeepIn(['flags'], flags);
    }

    case REMOVE_FLAG: {
      const {flag} = action.payload;

      if (action.error) {
      // Unable to delete flag, add it back in
        return state.setIn(['flags', flag.activityUrl], fromJS(flag));
      }

      return state.deleteIn(['flags', flag.get('activityUrl')]);
    }

    case UPDATE_FLAG_STATUS: {
      return state.mergeDeepIn(['status'], action.payload.status);
    }

    default: {
      return state;
    }
  }
}
